import styled from 'styled-components'

interface ContainerProps {
    size: number
}
export const Container = styled.div<ContainerProps>`
    width: ${
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (props) => `${props.size}px`
    };
    height: ${
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (props) => `${props.size}px`
    };
    overflow: hidden;
    background: none;
`
